module.exports = __webpack_public_path__ + "static/logo-beton-fachzeitschrift-b099c89f20ce273f390ba63098f9c043.svg";